<template>
  <div class="game-help-wrapper">
    <template v-if="!isHelpGuide">
      <div v-for="(item, index) in helpSource" :key="'item' + index">
        <div v-if="item.type === 'image'" :class="[item.class, { 'is-mobile': isMobile }]">
          <img :src="require(`@/assets/images/${item.value}`)" />
        </div>
        <div v-else-if="item.type === 'link'" v-html="item.value" :class="item.class" @click="toggleTNC(item.link)">
        </div>
        <LeftImage v-else-if="item.type === 'left-image-template'" :dataSource="item.config"></LeftImage>
        <div v-else :class="item.class" v-html="item.value"></div>
      </div>
    </template>
    <template v-else>
      <div class="help-tabs">
        <button v-for="tab in helpTabs" :key="tab.key" :class="['tab-button', { active: currentTab === tab.key }]"
          @click="currentTab = tab.key">
          {{ $t(tab.label) }}
        </button>
      </div>
      <div v-show="currentTab === 'ph'">
        <PhRules />
      </div>
      <div v-show="currentTab === 'cam'">
        <CamRules />
      </div>
      <div v-show="currentTab === 'table'">
        <TableTop />
      </div>
      <div v-show="currentTab === 'betGuide'">
        <BetGuide @toggleTnc="toggleTNC('tnc')" />
      </div>
    </template>
  </div>
</template>
<script>
  import { mapActions } from 'vuex';
  import { isMobile } from 'mobile-device-detect';
  import { PopupPage } from '@/utils/index.model';
  import LeftImage from '@/components/help/jackpot-left-image.vue';
  import PhRules from './help-rules/ph-rules.vue';
  import CamRules from './help-rules/cam-rules.vue';
  import TableTop from './help-rules/table-top.vue';
  import BetGuide from './help-rules/bet-guide.vue';

  export default {
    props: {
      helpSource: {
        type: Array,
        default: () => [],
      },
      isHelpGuide: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      PhRules,
      CamRules,
      TableTop,
      BetGuide,
      LeftImage
    },
    data: () => {
      return {
        currentTab: 'betGuide',
        helpTabs: [
          {
            key: 'betGuide',
            label: 'Bet guide',
          },
          {
            key: 'ph',
            label: 'Philippines',
          },
          {
            key: 'cam',
            label: 'Cambodia',
          },
          {
            key: 'table',
            label: 'Tabletop',
          },
        ],
        isMobile,
      };
    },
    methods: {
      ...mapActions('menu', ['updateMenu']),
      toggleTNC(link) {
        switch (link) {
          case 'tnc':
            this.updateMenu({
              activePopupPage: PopupPage.tnc,
            });
            break;
        }
      },
    },
  };
</script>
<style lang="scss">
  .game-help-wrapper {
    font-size: 12px;
    text-align: left;
    color: #b2d6ea;
    padding: 12px 24px;
    overflow-y: auto;
    height: calc(100% - 56px);
    box-sizing: border-box;
    line-height: 1.5;

    width: 100%;

    .help-tabs {
      display: flex;
      gap: 10px;
      margin-bottom: 20px;
      flex-wrap: wrap;

      .tab-button {
        padding: 8px 16px;
        border: none;
        border-radius: 6px;
        background: #333;
        color: #fff;
        cursor: pointer;
        transition: 0.2s;
        font-weight: 500;
        text-transform: uppercase;
      }

      .tab-button:hover {
        background: #555;
      }

      .tab-button.active {
        background: #fcc751;
        color: #000;
      }

    }

    >div {
      margin: 12px 0;
    }

    a {
      color: #b2d6ea;
    }

    img {
      width: 80%;
    }

    br {
      content: 'A' !important;
      display: block !important;
      margin: 8px 0;
    }

    .h1 {
      font-size: 14px;
      color: #fff;
      text-transform: uppercase;
      margin: 12px 0;
    }

    .h2 {
      font-size: 12px;
      color: #e4e7eb;
      text-transform: uppercase;
    }

    .m-r-8 {
      margin-right: 8px;
    }

    .m-l-8 {
      margin-left: 8px;
    }

    .m-l-16 {
      margin-left: 16px;
    }

    .m-l-32 {
      margin-left: 32px;
    }

    .bg-red {
      background-color: #c12828;
    }

    .bg-blue {
      background-color: #0073e8;
    }

    .bg-green {
      background-color: #187c40;
    }

    .text-red {
      color: #c12828;
      font-weight: 600;
    }

    .text-blue {
      color: #0073e8;
      font-weight: 600;
    }

    .text-green {
      color: #187c40;
      font-weight: 600;
    }

    .text-white {
      color: #fff;
    }

    .bold {
      font-weight: 600;
    }

    .p-8 {
      padding: 8px;
      box-sizing: border-box;
    }

    .br-4 {
      border-radius: 4px;
    }

    .break {
      height: 0;
      margin: 0;
    }

    .badge {
      min-width: 100px;
      max-width: 150px;
      text-align: center;
      height: 32px;
      margin: 8px 0;
      display: block;
      text-transform: uppercase;
    }

    .w-full {
      width: 100% !important;

      img {
        width: 100% !important;
      }
    }

    .desktop:not(.is-mobile) {
      img {
        width: 70% !important;
      }
    }
  }
</style>
